// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"681af971","488":"685b7b3e"}[chunkId] + ".chunk.js";
};